import { render, staticRenderFns } from "./TestConstructorEditor.vue?vue&type=template&id=442e7d3a&scoped=true&"
import script from "./TestConstructorEditor.vue?vue&type=script&lang=js&"
export * from "./TestConstructorEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442e7d3a",
  null
  
)

export default component.exports